import React, { useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  FormLabel,
  MenuItem,
  Stack,
  TextField,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { createReportJob } from "../../../store/Reports/reportsThunks";
import { areaOptions } from "../../../constants/areas";
import { functionOptions } from "../../../constants/functions";
import { routeOptions } from "../../../constants/routes";

const reportTypes = [
  { value: "playback", label: "Playback" },
  // Extend as needed
];

const ReportForm = ({ onSuccess }) => {
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.reports);

  const [form, setForm] = useState({
    report_type: "playback",
    start_time: "",
    end_time: "",
    function: "",
    route: "",
    area: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: undefined }));
  };

  const validate = () => {
    const newErrors = {};
    if (!form.report_type) newErrors.report_type = "Report type is required";
    if (!form.start_time) newErrors.start_time = "Start time is required";
    if (!form.end_time) newErrors.end_time = "End time is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;
    const normalize = (value) => (value === "" ? null : value);

    const payload = {
      reportType: form.report_type,
      startTime: form.start_time,
      endTime: form.end_time,
      function: normalize(form.function),
      route: normalize(form.route),
      area: normalize(form.area),
    };

    dispatch(createReportJob(payload)).then(() => {
      if (onSuccess) onSuccess();
    });
  };

  return (
    <form onSubmit={handleSubmit} noValidate>
      <Stack spacing={3}>
        <FormControl fullWidth>
          <FormLabel>Report Type</FormLabel>
          <TextField
            select
            name="report_type"
            value={form.report_type}
            onChange={handleChange}
            error={!!errors.report_type}
            helperText={errors.report_type}
          >
            {reportTypes.map((type) => (
              <MenuItem key={type.value} value={type.value}>
                {type.label}
              </MenuItem>
            ))}
          </TextField>
        </FormControl>

        <FormControl fullWidth>
          <FormLabel>Start Time</FormLabel>
          <TextField
            type="datetime-local"
            name="start_time"
            value={form.start_time}
            onChange={handleChange}
            error={!!errors.start_time}
            helperText={errors.start_time}
          />
        </FormControl>

        <FormControl fullWidth>
          <FormLabel>End Time</FormLabel>
          <TextField
            type="datetime-local"
            name="end_time"
            value={form.end_time}
            onChange={handleChange}
            error={!!errors.end_time}
            helperText={errors.end_time}
          />
        </FormControl>

        <FormControl fullWidth>
          <FormLabel>Function</FormLabel>
          <TextField
            select
            name="function"
            value={form.function}
            onChange={handleChange}
          >
            {functionOptions.map((option) => (
              <MenuItem key={option} value={option}>
                {option.replace(/_/g, " ")}
              </MenuItem>
            ))}
          </TextField>
        </FormControl>

        <FormControl fullWidth>
          <FormLabel>Route</FormLabel>
          <TextField
            select
            name="route"
            value={form.route}
            onChange={handleChange}
          >
            {routeOptions.map((option) => (
              <MenuItem key={option} value={option}>
                {option.replace(/_/g, " ")}
              </MenuItem>
            ))}
          </TextField>
        </FormControl>

        <FormControl fullWidth>
          <FormLabel>Area</FormLabel>
          <TextField
            select
            name="area"
            value={form.area}
            onChange={handleChange}
          >
            {areaOptions.map((option) => (
              <MenuItem key={option} value={option}>
                {option.replace(/_/g, " ")}
              </MenuItem>
            ))}
          </TextField>
        </FormControl>

        <Button
          type="submit"
          variant="contained"
          disabled={loading}
          startIcon={loading && <CircularProgress size={20} />}
        >
          Generate Report
        </Button>
      </Stack>
    </form>
  );
};

export default ReportForm;
